import { Button, ErrorState, StatusPage, TOUCH } from "@nymbl/nos2-rules";
import { useRouter, useRouterState } from "@tanstack/react-router";

const TRY_AGAIN = "This page couldn't load.";

/**
 * Router-wide fallback so a failed load shows a retry, not a raw error screen. Inside the shell the
 * page's own area shows it; a guard that stopped the shell loading gets a whole page.
 */
export function RouteError() {
  const router = useRouter();
  const inShell = useRouterState({
    select: (s) => s.matches.some((m) => m.routeId === "/dashboard" && m.status === "success"),
  });
  if (inShell) {
    return (
      <div className="rounded-lg border bg-card">
        <ErrorState message={TRY_AGAIN} onRetry={() => void router.invalidate()} />
      </div>
    );
  }
  return (
    <StatusPage
      kind="error"
      actions={
        <Button className={TOUCH} onClick={() => void router.invalidate()}>
          Try again
        </Button>
      }
    />
  );
}
